
// Check if the target is null or undefined. Globally available function
export function isNullOrUndefined(target: any){
  if(target){
      return false;
  }else{
      return true;
  }
}
